/**************************************************
 * Nombre:       Productos_Formulario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Rating, Typography} from "@mui/material";
import estrella from '../../../../Recursos/ic_estrella.svg'
import {theme} from "../../../../Tema";
import {useFormulario} from "../../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Producto from "../../../Formularios/Formulario_Producto";


const Productos_Formulario = () => {
    const {props} = useFormulario({valoresDefecto: {}})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={estrella} width={40} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1, mb: 1}}>
                <Typography sx={{fontSize: 20, fontWeight: 600}}>Califica este producto</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Producto props={props} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                <Button sx={{pt: 1, pb: 0.8}}>Comentar</Button>
            </Grid>

        </Grid>
    )

}
export default Productos_Formulario    